import { LOGISTICS_TYPES, OWNER_TYPES } from '~/constants/common';
import type { TypeLogisticsType } from '~/constants/common';

import type { TypeTestAccount } from './types';

export type TypeAccountGroup = {
  label: string;
  accounts: TypeTestAccount[];
};

const OWNER_ORDER: Record<TypeTestAccount['ownerType'], number> = {
  [OWNER_TYPES['3PL']]: 0,
  [OWNER_TYPES.FBK]: 1,
  [OWNER_TYPES.NFA]: 2,
};

const LOGISTICS_LABEL: Record<TypeLogisticsType, string> = {
  [LOGISTICS_TYPES.FULFILLMENT]: '풀필먼트',
  [LOGISTICS_TYPES.DELIVERY]: '배송대행',
};

const LOGISTICS_ORDER: TypeLogisticsType[] = [LOGISTICS_TYPES.FULFILLMENT, LOGISTICS_TYPES.DELIVERY];

const getLogisticsSortKey = (types: TypeLogisticsType[]) => {
  if (types.length === 0) return -1;
  if (types.length === 1) return LOGISTICS_ORDER.indexOf(types[0]);
  return LOGISTICS_ORDER.length;
};

const getLogisticsLabel = (types: TypeLogisticsType[]) => {
  if (types.length === 0) return '';
  return LOGISTICS_ORDER.filter((t) => types.includes(t))
    .map((t) => LOGISTICS_LABEL[t])
    .join('/');
};

const getGroupLabel = (ownerType: TypeTestAccount['ownerType'], logisticsTypes: TypeLogisticsType[]) => {
  const logisticsLabel = getLogisticsLabel(logisticsTypes);
  return logisticsLabel ? `${ownerType} · ${logisticsLabel}` : ownerType;
};

export const groupAccounts = (accounts: TypeTestAccount[]): TypeAccountGroup[] => {
  const sorted = [...accounts].sort((a, b) => {
    const ownerDiff = OWNER_ORDER[a.ownerType] - OWNER_ORDER[b.ownerType];
    if (ownerDiff !== 0) return ownerDiff;
    const logisticsDiff = getLogisticsSortKey(a.logisticsTypes) - getLogisticsSortKey(b.logisticsTypes);
    if (logisticsDiff !== 0) return logisticsDiff;
    return a.loginId.localeCompare(b.loginId);
  });

  const groups: TypeAccountGroup[] = [];
  for (const account of sorted) {
    const label = getGroupLabel(account.ownerType, account.logisticsTypes);
    const lastGroup = groups[groups.length - 1];
    if (lastGroup?.label === label) {
      lastGroup.accounts.push(account);
    } else {
      groups.push({ label, accounts: [account] });
    }
  }
  return groups;
};
